import { StrictMode } from 'react'
import '../i18n'
import { createRoot } from 'react-dom/client'
import '../index.css'
import Home from '../pages/home/page'
import Navbar from '../components/feature/Navbar'
import WechatFloat from '../components/feature/WechatFloat'
import { I18nextProvider } from "react-i18next";
import i18n from "../i18n";

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <I18nextProvider i18n={i18n}>
      <Navbar />
      <WechatFloat />
      <Home />
    </I18nextProvider>
  </StrictMode>,
)
